import { NavLink } from "react-router-dom";
import { FaBars, FaHome, FaLock, FaMoneyBill, FaUser } from "react-icons/fa";
import { MdMessage } from "react-icons/md";
import { BiAnalyse, BiSearch } from "react-icons/bi";
import { BiCog } from "react-icons/bi";
import { BiDollarCircle } from "react-icons/bi";
import { BiGroup } from "react-icons/bi";
import { AiFillHeart, AiTwotoneFileExclamation } from "react-icons/ai";
import { BsCartCheck } from "react-icons/bs";
import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import SidebarMenu from "./SidebarMenu";
import { useTranslation } from "react-i18next";
import logo from "../../Images/logo.jpg"
import { useSelector } from "react-redux";




const SideBar = ({ children }) => {

  const color = useSelector(
    (state) => state.settingsReducers.oneSettings.primaryColor
  );

  const { t } = useTranslation();
  const routes = [
    {
      path: "/admin/allusers?page=1",
      name: t("users"),
      icon: <FaHome />,
    },
    {
      path: "/admin/allnews",
      name: 'الاخبار',
      icon: <FaHome />,
    },
    {
      path: "/admin/countries",
      name: t("countries"),
      icon: <FaHome />,
    },
    {
      path: "/admin/documents",
      name: t("الوثائق والمستندات"),
      icon: <FaHome />,
    },
    {
      path: "/admin/fixedpages",
      name: "الصفحات الثابتة",
      icon: <FaHome />,
    },

    {
      path: "/admin/polls",
      name: "الاستبيان",
      icon: <FaHome />,
    },

    {
      path: "/admin/mainchar",
      name: "التصنيفات للشخصيات",
      icon: <FaHome />,
    },


    {
      path: "/admin/contact",
      name: "التواصل",
      icon: <FaHome />,
    },
    {
      path:"/admin/galleries",
      name:'معرض الصور',
      icon: <FaHome />,
    },

    {
      path: "/settings",
      name: t("Settings"),
      icon: <BiCog />,
      exact: true,
      subRoutes: [
        {
          path: "/admin/settings",
          name: t("Site Settings"),
          icon: <FaUser />,
        },
      ],
    },

  ];
  const [isOpen, setIsOpen] = useState(true);
  const toggle = () => setIsOpen(!isOpen);
  const inputAnimation = {
    hidden: {
      width: 0,
      padding: 0,
      transition: {
        duration: 0.2,
      },
    },
    show: {
      width: "140px",
      padding: "5px 15px",
      transition: {
        duration: 0.2,
      },
    },
  };

  const showAnimation = {
    hidden: {
      width: 0,
      opacity: 0,
      transition: {
        duration: 0.5,
      },
    },
    show: {
      opacity: 1,
      width: "auto",
      transition: {
        duration: 0.5,
      },
    },
  };

  return (
    <>
      <div className="main-container h-100">
        <motion.div
          animate={{
            width: isOpen ? "200px" : "45px",

            transition: {
              duration: 0.5,
              type: "spring",
              damping: 10,
            },
          }}
          className={`sidebarMenu `}
          style={{ backgroundColor: color }}
        >
          <div className="top_section">
            <AnimatePresence>
              {isOpen && (
                <motion.h1
                  variants={showAnimation}
                  initial="hidden"
                  animate="show"
                  exit="hidden"
                  className="logoMenu"
                >
                  {t("control panal")}
                </motion.h1>
              )}
            </AnimatePresence>

            <div className="bars">
              <FaBars onClick={toggle} />
            </div>
          </div>
        
          <section className="routes">
            {routes.map((route, index) => {
            //  console.log('index',index);
              if (route.subRoutes) {
                return (
                  <SidebarMenu
                    key={index}
                    setIsOpen={setIsOpen}
                    route={route}
                    showAnimation={showAnimation}
                    isOpen={isOpen}
                  />
                );
              }

              return (
                <NavLink
                  to={route.path}
                  key={index}
                  className="link"
                  activeClassName="active"
                >
                  <div className="icon">{route.icon}</div>
                  <AnimatePresence>
                    {isOpen && (
                      <motion.div
                        variants={showAnimation}
                        initial="hidden"
                        animate="show"
                        exit="hidden"
                        className="link_text"
                      >
                        {route.name}
                      </motion.div>
                    )}
                  </AnimatePresence>
                </NavLink>
              );
            })}
          </section>
        </motion.div>

        <main>{children}</main>
      </div>
    </>
  );
};

export default SideBar;
